import { check } from '@placemarkio/check-geojson';
import type { GeoJSON } from 'geojson';
import type { CanonicalGeographyFeature } from '../state/api/organisationEngineSlice';

export type NormaliseGeoJsonFileProps = {
    convertGeoJSONToGeography: (input: GeoJSON) => Promise<CanonicalGeographyFeature>;
};

/**
 * Reads a GeoJSON file, validates its structure locally with `check()` (per
 * ADR-002), and asks the engine to normalise it into a write-ready canonical
 * Feature. Persistence — POST /geography or PUT /geographies/{id} — is the
 * caller's decision; this helper just gets the file into the shape both
 * write endpoints accept.
 */
export async function normaliseGeoJsonFile(
    { convertGeoJSONToGeography }: NormaliseGeoJsonFileProps,
    args: { file: File }
): Promise<CanonicalGeographyFeature> {
    const parsed = check(await args.file.text());
    return convertGeoJSONToGeography(parsed);
}
